import type { FunctionComponent } from "react";
import { Button, CopyContent } from "@kanda-libs/ks-design-library";
import {
  CLASS_NAMES,
  COPIED_BUTTON_PROPS,
  COPY_BUTTON_PROPS,
} from "components/company/CompanyLayout/CompanyDetails/Company/ApiKey/constants";

export interface ApiKeyProps {
  apiKey?: string;
}

const ApiKey: FunctionComponent<ApiKeyProps> = function ({ apiKey = "" }) {
  return (
    <div className={CLASS_NAMES.container}>
      <CopyContent
        content={apiKey}
        clickedView={<Button.Link {...COPIED_BUTTON_PROPS} size={14} />}
      >
        <Button.Link {...COPY_BUTTON_PROPS} size={14} />
      </CopyContent>
    </div>
  );
};

export default ApiKey;
